import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Created Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "prepend",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products/${args?.id}`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Update Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products/${args?.id}`,
      method: "delete",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Deleted Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "products",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
      cacheTTL: 120000,
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);

    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const removeImage = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products/images/${args?.id}`,
      method: "delete",
      authorization: true,

      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const removeVariation = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products/variations/${args?.id}`,
      method: "delete",
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products/${args.id}`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 300000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const removeRecommendation = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products/${args?.id}/recommendations/${args?.data?.recommendedProductId}`,
      method: "delete",
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const addRecommendation = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products/${args?.id}/recommendations`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getRecommendations = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products/${args.id}/recommendations`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
      },
      cacheTTL: 120000,
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getRecommendationCandidates = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products/${args.id}/recommendation-candidates`,
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
      cacheTTL: 120000,
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getTasks = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "products/tasks",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const retryTask = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `products/tasks/${args.id}/retry`,
      method: "post",
      authorization: true,
      config: {
        successMsg: "Retry initiated",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  find,
  list,
  create,
  update,
  remove,
  removeImage,
  removeVariation,
  addRecommendation,
  removeRecommendation,
  getRecommendations,
  getRecommendationCandidates,
  getTasks,
  retryTask,
};
